import {lazy} from "react";

export const DeviceActivityLazy = lazy(()=>import('./DeviceActivity'))